import React from 'react';
import { ButtonV2, Flex } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useListingsPanelTelemetry } from '../ListingsPanel.telemetry';

interface HotelCTAProps {
  joyPlaceId: string;
  hotelName?: string;
  redirectUrl: string;
}

export const HotelCTA = ({ joyPlaceId, hotelName, redirectUrl }: HotelCTAProps) => {
  const { t } = useTranslation('accommodationsConsole');
  const hotelCTATrans = t('listingsPanel');
  const telemetry = useListingsPanelTelemetry();
  const handleSeeAvailability = useEventCallback(() => {
    telemetry.seeAvailabilityClicked({ joyPlaceId, hotelName });
  });

  return (
    <Flex width={{ _: '100%', md: 'fit-content' }}>
      <ButtonV2
        variant="solid"
        intent="newPrimary"
        _hover={{ backgroundColor: { _: 'newUIBrandPrimary', md: 'buttonNewPrimaryHover' } }}
        width="100%"
        height={{ _: '48px', md: '40px' }}
        onClick={handleSeeAvailability}
        shape="rounded"
        as="a"
        href={redirectUrl}
        target="_blank"
      >
        {hotelCTATrans.hotelCTA.title()}
      </ButtonV2>
    </Flex>
  );
};
